<template>
  <div class="card modal-card-validation modal-card-border">
    <div class="card-content">
      <section>
        <p class="subtitle is-4 has-text-centered">
          Valider définitivement
        </p>
        <p class="is-size-14px has-text-centered">
          Attention, vous allez transférer cette opportunité dans la gestion commerciale.
          Elle ne pourra plus être modifiée / supprimée.
        </p>
      </section>
      <br>
      <footer>
        <div class="mt-20">
          <button class="button button-modal has-text-centered"
            @click="$emit('close')">
            Annuler
          </button>
          <button class="button is-primary button-modal has-text-centered ml-5px"
            @click="$emit('valider')">
            Valider
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'validation-op',
};
</script>

<style scoped>
.button-modal {
  width: 84px;
}
.modal-card-validation {
  padding-right: 26px !important;
  padding-left: 26px !important;
  padding-bottom: 26px !important;
  padding-top: 11px !important;
}
.card {
  width: 400px;
  height: 280px;
  top: 5rem;
  left: calc(50% - 200px);
  position: fixed !important;
}

</style>



// WEBPACK FOOTER //
// src/components/mesOpportunites/detail/validerDefinitivement.vue